import React from 'react'
import { Field as Input, FieldArray as InputArray, reduxForm } from 'redux-form'

import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button'
import ClearIcon from '@material-ui/icons/Clear';
import Grid from '@material-ui/core/Grid'
import SendIcon from '@material-ui/icons/Send';
import { withStyles } from '@material-ui/core/styles';

import { TextInput } from '../../Inputs'
import { SchemaField } from './SchemaField'
import { validate } from './validate'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';


const styles = {
    form: {
        margin: '20px'
    },
    button: {
        icon: {
            marginRight: '10px'
        }
    }
}

const Toolbar = withStyles(styles)((props) => {
    const { pristine, submitting, invalid, reset, classes, edit } = props;
    return (
        <Grid container justify="space-between">
            <Grid item xs={12} md={2} lg={4}>
                <Button
                    type="submit"
                    disabled={invalid || submitting}
                    color="primary"
                >
                    <SendIcon className={classes.button.icon}/>
                    {edit ? "Guardar" : "Crear"}
                </Button>
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
                <Button
                    type="button"
                    disabled={pristine || submitting}
                    onClick={reset}
                    color="secondary"
                >
                    <ClearIcon style={classes.button.icon}/>
                    Limpiar
                </Button>
            </Grid>
        </Grid>
    )
});


const renderFields = withStyles(styles)(({ fields, classes }) => {
    return (
        <div>
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell></TableCell> */}
                            <TableCell align="center">Nombre Dato Técnico</TableCell>
                            <TableCell align="center">Tipo</TableCell>
                            <TableCell align="center" padding={"none"}>Obligatorio</TableCell>
                            <TableCell padding={"none"}>Eliminar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {fields.map((name, index, fields) => (
                        <SchemaField
                            key={name}
                            fieldName={name}
                            index={index}
                            fields={fields}
                        />
                    ))}
                    </TableBody>
                </Table>
            </Paper>
            <Button
                onClick={() => fields.push({})}
                variant="contained"
                color="primary"
                title="Agregar campo"
            >
                <AddIcon className={classes.button.icon}/>
                Agregar Campo
            </Button>
        </div>
    )
})

const EsquemaForm = (props) => {
    const {
        save,
        pristine,
        reset,
        submitting,
        redirect,
        invalid,
        handleSubmit,
        classes,
        edit
    } = props

    const toolbarActions = {
        pristine,
        submitting,
        invalid,
        reset,
        edit
    }

    return (
        <form
            onSubmit={handleSubmit(values => save(values, redirect))}
            className={classes.form}
        >
            <Grid container spacing={16}>
                <Grid item xs={12} md={2} lg={4}>
                    <Input
                        name="name"
                        component={TextInput}
                        type="text"
                        label="Nombre"
                        required={true}
                    />
                </Grid>
                <Grid item xs={12} md={2} lg={4}>
                    <Input
                        name="description"
                        component={TextInput}
                        type="text"
                        label="Descripción"
                        required={false}
                    />
                </Grid>
                <Grid item xs={12}>
                    <InputArray name="fields" component={renderFields}/>
                </Grid>
                <Grid item xs={12}>
                    <Toolbar {...toolbarActions} />
                </Grid>
            </Grid>
        </form>
    )
}

export default reduxForm({
    form: 'redux-form',
    validate
})(withStyles(styles)(EsquemaForm))
